import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {} }
const _hoisted_2 = {
  key: 0,
  id: "inicio",
  class: "d-md-flex wrap justify-content-between align-items-center w-100"
}
const _hoisted_3 = { class: "me-5 col-lg-4 card-title fw-bolder fs-3 cor_texto_1 w-100 mb-sm-4 mb-4 mb-md-0 text-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "m-0 card-title fw-bolder fs-3 cor_texto_1" }, "Sugestão para estoque", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-7 m-0"
}
const _hoisted_6 = { class: "d-sm-flex align-items-center justify-content-end w-100" }
const _hoisted_7 = { class: "me-5 mw-xl-350px" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil-alt cor_btn_1 p-3" }, null, -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.4rem"},
    class: "fas bi-arrow-clockwise"
  }),
  /*#__PURE__*/_createTextVNode(" Atualizar estoque ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "dataTables_empty card shadow-sm mt-6"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "3",
  rx: "3",
  ry: "3",
  width: "906",
  height: "17"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "73",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("rect", {
  x: "254",
  y: "72",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("rect", {
  x: "440",
  y: "72",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("rect", {
  x: "610",
  y: "72",
  rx: "3",
  ry: "3",
  width: "260",
  height: "80"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "170",
  rx: "0",
  ry: "3",
  width: "898",
  height: "20"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("rect", {
  x: "254",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("rect", {
  x: "440",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("rect", {
  x: "610",
  y: "215",
  rx: "3",
  ry: "3",
  width: "260",
  height: "80"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "320",
  rx: "0",
  ry: "3",
  width: "898",
  height: "20"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("rect", {
  x: "254",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("rect", {
  x: "440",
  y: "215",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("rect", {
  x: "610",
  y: "215",
  rx: "3",
  ry: "3",
  width: "260",
  height: "80"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "320",
  rx: "0",
  ry: "3",
  width: "898",
  height: "20"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "370",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("rect", {
  x: "254",
  y: "370",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("rect", {
  x: "440",
  y: "370",
  rx: "3",
  ry: "3",
  width: "141",
  height: "80"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("rect", {
  x: "610",
  y: "370",
  rx: "3",
  ry: "3",
  width: "260",
  height: "80"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "320",
  rx: "0",
  ry: "3",
  width: "898",
  height: "20"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "7",
  rx: "3",
  ry: "3",
  width: "2",
  height: "465"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("rect", {
  x: "898",
  y: "7",
  rx: "3",
  ry: "3",
  width: "2",
  height: "465"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "470",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1",
  y: "38",
  rx: "3",
  ry: "3",
  width: "906",
  height: "17"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "15",
  rx: "3",
  ry: "3",
  width: "68",
  height: "33"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("rect", {
  x: "171",
  y: "12",
  rx: "3",
  ry: "3",
  width: "149",
  height: "33"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("rect", {
  x: "493",
  y: "13",
  rx: "3",
  ry: "3",
  width: "137",
  height: "33"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("rect", {
  x: "731",
  y: "14",
  rx: "3",
  ry: "3",
  width: "72",
  height: "33"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("rect", {
  x: "882",
  y: "12",
  rx: "3",
  ry: "3",
  width: "24",
  height: "33"
}, null, -1)
const _hoisted_44 = {
  style: {"border-bottom":"1px solid #B5B5C3"},
  class: "d-flex flex-column flex-xl-row m-0 px-5 pb-1"
}
const _hoisted_45 = { class: "p-0 d-flex align-items-center" }
const _hoisted_46 = { class: "text-uppercase mb-2 mb-xl-0" }
const _hoisted_47 = { class: "fw-bolder fs-6 cor_texto_1 text-nowrap m-0" }
const _hoisted_48 = {
  key: 1,
  class: "fw-bolder fs-6 cor_texto_1 text-nowrap m-0"
}
const _hoisted_49 = { class: "p-md-0 p-0 w-100" }
const _hoisted_50 = { class: "d-md-flex d-block justify-content-end" }
const _hoisted_51 = { class: "d-flex align-items-center mt-4 mt-md-0 me-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("h6", {
    style: {"font-weight":"100"},
    class: "text-muted text-nowrap fs-7 m-0"
  }, "Fornecedor")
], -1)
const _hoisted_53 = { class: "text-uppercase w-100 mb-2 mb-md-0" }
const _hoisted_54 = {
  style: {"border":"1px solid #D6D6D6","border-radius":"4px"},
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_55 = {
  key: 0,
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modallog_1",
  style: {"height":"25px"}
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil-alt cor_btn_1" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "d-flex align-items-center me-3 mb-2 mb-md-0" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("h6", {
    style: {"font-weight":"100"},
    class: "text-muted text-nowrap fs-7 m-0"
  }, "Peça")
], -1)
const _hoisted_61 = { class: "text-uppercase w-100" }
const _hoisted_62 = {
  style: {"border":"1px solid #D6D6D6","border-radius":"4px"},
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_63 = {
  key: 0,
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modallog_2",
  style: {"height":"25px"}
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil-alt cor_btn_1" }, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "d-flex align-items-center me-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("h6", {
    style: {"font-weight":"100"},
    class: "text-muted text-nowrap fs-7 m-0"
  }, "Und Caixa")
], -1)
const _hoisted_69 = { class: "text-uppercase w-100" }
const _hoisted_70 = {
  style: {"border":"1px solid #D6D6D6","border-radius":"4px"},
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_71 = {
  key: 0,
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modallog_3",
  style: {"height":"25px"}
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil-alt cor_btn_1" }, null, -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "d-flex align-items-center" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("p", {
    style: {"font-weight":"100"},
    class: "mb-0 text-muted text-nowrap fs-7 cor_texto"
  }, "Valor Unit:")
], -1)
const _hoisted_77 = { class: "text-uppercase mt-4 mt-md-0" }
const _hoisted_78 = { class: "ms-4 text-nowrap fs-7" }
const _hoisted_79 = { class: "row px-5 py-2" }
const _hoisted_80 = { class: "col-xl-5 d-flex justify-content-around" }
const _hoisted_81 = { class: "h-100" }
const _hoisted_82 = { class: "d-flex align-items-center justify-content-start h-100" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-100 d-flex justify-content-center flex-column pe-10",
  style: {"margin":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center d-flex w-100 justify-content-center w-100" }, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"font-size":"23px"},
      class: "cor_layout_2 fa fa-shopping-cart"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h6", {
    style: {"font-weight":"100"},
    class: "cor_layout_2 mt-3 text-center mb-0"
  }, "Vendas")
], -1)
const _hoisted_84 = { class: "text-nowrap w-100 text-muted borda-vendas" }
const _hoisted_85 = {
  key: 0,
  class: "d-md-flex"
}
const _hoisted_86 = {
  key: 0,
  class: "me-3"
}
const _hoisted_87 = {
  key: 0,
  class: ""
}
const _hoisted_88 = {
  key: 1,
  class: "m-0"
}
const _hoisted_89 = { class: "h-100" }
const _hoisted_90 = { class: "d-flex align-items-center justify-content-center h-100" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "text-center pe-10" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"23px"},
    class: "cor_layout_2 fas fa-file-invoice-dollar"
  }),
  /*#__PURE__*/_createElementVNode("h6", {
    style: {"font-weight":"100"},
    class: "cor_layout_2 mt-3 mb-0"
  }, "Demanda")
], -1)
const _hoisted_92 = { class: "text-start ps-10 borda text-muted d-flex flex-column" }
const _hoisted_93 = { class: "align-items-start text-nowrap" }
const _hoisted_94 = { class: "align-items-center text-nowrap" }
const _hoisted_95 = { class: "align-items-end text-nowrap" }
const _hoisted_96 = { class: "col-xl-3 col-sm-4 d-flex flex-column justify-content-sm-around mb-5 mb-md-0 px-lg-0 px-xl-10 borda-dados" }
const _hoisted_97 = { class: "d-flex justify-content-between" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h6", { class: "cor_texto_1 text-nowrap mb-sm-0 fs-7" }, "Estoque atual: ", -1)
const _hoisted_99 = { class: "text-nowrap" }
const _hoisted_100 = { class: "d-flex justify-content-between" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("h6", { class: "cor_texto_1 text-nowrap mb-sm-0 fs-7" }, "Última Compra: ", -1)
const _hoisted_102 = { class: "text-nowrap" }
const _hoisted_103 = { class: "d-flex justify-content-between" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "cor_texto_1 h6 text-nowrap mb-0 fs-7" }, "Documento: ", -1)
const _hoisted_105 = { class: "text-nowrap" }
const _hoisted_106 = { class: "col-xl-4 col-sm-8" }
const _hoisted_107 = {
  style: {"background":"var(--cor_background_3)","border-radius":"11px"},
  class: "px-4 py-1"
}
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-lg-7 p-0" }
const _hoisted_110 = {
  style: {"background":"var(--cor_background_1)","border-radius":"8px"},
  class: "w-100 d-flex justify-content-between mb-lx-0 mb-4 mb-md-0 mb-xl-0"
}
const _hoisted_111 = {
  key: 0,
  style: {"background":"var(--cor_indicadores_3_opct)","border-radius":"8px 0px 0px 8px"},
  class: "p-2 d-flex align-items-center"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "fs-1 cor_indicadores_3 bi bi-exclamation-lg" }, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "pt-3 pb-0 m-auto" }
const _hoisted_115 = { class: "h3 cor_texto_1 text-center cor_texto_1 m-0 p-0" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", { class: "cor_texto_2 m-0 pb-2 fs-7" }, "Recomendado", -1)
const _hoisted_117 = { class: "align-items-end" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = { key: 1 }
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { key: 2 }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { key: 3 }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "col-lg-5 mt-0 mt-lg-0 py-1" }
const _hoisted_127 = {
  style: {},
  class: "h-100 d-flex flex-lg-column justify-content-between"
}
const _hoisted_128 = { class: "d-flex justify-content-between align-items-center cor_texto_1" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-0 cor_texto_1 fs-7" }, "Valor:", -1)
const _hoisted_130 = { class: "fw-bolder fs-5 m-0 fs-md-6 cor_texto_1" }
const _hoisted_131 = { class: "d-flex justify-content-between cor_texto_1" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("p", { class: "h6 cor_texto_1 fs-7" }, "Estoque:", -1)
const _hoisted_133 = { class: "ms-4 text-nowrap fs-7" }
const _hoisted_134 = {
  key: 0,
  class: "message-email text-start text-muted px-7"
}
const _hoisted_135 = {
  class: "d-flex position-fixed mb-2 me-2",
  style: {"z-index":"100000","position":"fixed","bottom":"0","right":"0"}
}
const _hoisted_136 = { key: 0 }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }),
  /*#__PURE__*/_createTextVNode(" Salvar ")
], -1)
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = {
  key: 1,
  class: "d-flex fw-bolder fs-4 fs-md-6 cor_texto_total"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("svg", {
  class: "me-2",
  width: "12",
  height: "18",
  viewBox: "0 0 22 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.6562 0.5H2.46875C1.21875 0.5 0.125 1.59375 0.125 2.84375V23.1562C0.125 24.4062 1.21875 25.5 2.46875 25.5H19\n                .6562C20.9062 25.5 22 24.4062 22 23.1562V2.84375C22 1.59375 20.9062 0.5 19.6562 0.5ZM6.375 21.75C6.375 22.0625 6.0625 \n                22.375 5.75 22.375H3.875C3.5625 22.375 3.25 22.0625 3.25 21.75V19.875C3.25 19.5625 3.5625 19.25 3.875 19.25H5.75C6.0625 \n                19.25 6.375 19.5625 6.375 19.875V21.75ZM6.375 15.5C6.375 15.8125 6.0625 16.125 5.75 16.125H3.875C3.5625 16.125 3.25 15.8125 \n                3.25 15.5V13.625C3.25 13.3125 3.5625 13 3.875 13H5.75C6.0625 13 6.375 13.3125 6.375 13.625V15.5ZM12.625 21.75C12.625 22.0625 \n                12.3125 22.375 12 22.375H10.125C9.8125 22.375 9.5 22.0625 9.5 21.75V19.875C9.5 19.5625 9.8125 19.25 10.125 19.25H12C12.3125 \n                19.25 12.625 19.5625 12.625 19.875V21.75ZM12.625 15.5C12.625 15.8125 12.3125 16.125 12 16.125H10.125C9.8125 16.125 9.5 15.8125 \n                9.5 15.5V13.625C9.5 13.3125 9.8125 13 10.125 13H12C12.3125 13 12.625 13.3125 12.625 13.625V15.5ZM18.875 21.75C18.875 22.0625 \n                18.5625 22.375 18.25 22.375H16.375C16.0625 22.375 15.75 22.0625 15.75 21.75V13.625C15.75 13.3125 16.0625 13 16.375 13H18.25C18.5625 \n                13 18.875 13.3125 18.875 13.625V21.75ZM18.875 9.25C18.875 9.5625 18.5625 9.875 18.25 9.875H3.875C3.5625 9.875 3.25 9.5625 3.25 9.25V4.25C3.25\n                3.9375 3.5625 3.625 3.875 3.625H18.25C18.5625 3.625 18.875 3.9375 18.875 4.25V9.25Z",
    fill: "#0BB783"
  })
], -1)
const _hoisted_142 = {
  key: 3,
  class: "row mt-3"
}
const _hoisted_143 = { class: "col-xl-6 col-xs-12 col-12 col-sm-6" }
const _hoisted_144 = { class: "left text-center text-sm-start" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { class: "col-xl-6 col-xs-12 text-center text-sm-end col-12 col-sm-6 mt-3 mt-sm-0" }
const _hoisted_147 = { key: 4 }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "45",
    height: "46",
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22.5 0.5C10.0745 0.5 0 10.5781 0 23C0 35.4292 10.0745 45.5 22.5 45.5C34.9255 45.5 45 35.4292 45 23C45 10.5781 34.9255 0.5 22.5 0.5ZM22.5 10.4798C24.6045 10.4798 26.3105 12.1858 26.3105 14.2903C26.3105 16.3948 24.6045 18.1008 22.5 18.1008C20.3955 18.1008 18.6895 16.3948 18.6895 14.2903C18.6895 12.1858 20.3955 10.4798 22.5 10.4798ZM27.5806 33.5242C27.5806 34.1254 27.0932 34.6129 26.4919 34.6129H18.5081C17.9068 34.6129 17.4194 34.1254 17.4194 33.5242V31.3468C17.4194 30.7455 17.9068 30.2581 18.5081 30.2581H19.5968V24.4516H18.5081C17.9068 24.4516 17.4194 23.9641 17.4194 23.3629V21.1855C17.4194 20.5842 17.9068 20.0968 18.5081 20.0968H24.3145C24.9158 20.0968 25.4032 20.5842 25.4032 21.1855V30.2581H26.4919C27.0932 30.2581 27.5806 30.7455 27.5806 31.3468V33.5242Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_149 = {
  class: "position-relative",
  style: {"color":"#FFFFFF","width":"100%"}
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("h5", {
  class: "mt-2",
  style: {"color":"#FFFFFF"}
}, "Atenção!", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"400"} }, "O estoque está desatualizado. Por favor, atualize-o.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_spam = _resolveComponent("spam")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ModalUpdateCodFornecedor = _resolveComponent("ModalUpdateCodFornecedor")!
  const _component_ModalUpdateCodPeca = _resolveComponent("ModalUpdateCodPeca")!
  const _component_ModalUpdateUnidadeCaixa = _resolveComponent("ModalUpdateUnidadeCaixa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.animate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.dataUltimaAtt)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Última atualização do estoque: " + _toDisplayString(_ctx.dataUltimaAtt), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.todosProdutos.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.seachServico,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.seachServico) = $event)),
                      onKeyup: _ctx.searchServico,
                      class: "w-100",
                      placeholder: "Pesquisar produto..."
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeyup"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.diasSegurancaEstoque)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.distribuidorAtualizarEstoque() && _ctx.existeDms ? 'me-5 mt-5 mt-sm-0' : 'me-0 mt-5 mt-sm-0')
                }, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.diasSegurancaEstoque,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.diasSegurancaEstoque) = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDiasSegurancaEstoque())),
                    placeholder: "Select",
                    style: {"width":"240px"},
                    disabled: !_ctx.isEdit
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diasSegurancaEstoqueOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.text,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.avisoAttEstoque && _ctx.avisoAttEstoque(...args))),
                class: "btn btn-flex btn_background_1 btn-flex cor_btn_1 btn-sm w-100",
                style: {"height":"32px"},
                id: "buttonAtualizaEstoque"
              }, _hoisted_12, 512), [
                [_vShow, _ctx.todosProdutos.length > 0 && _ctx.distribuidorAtualizarEstoque() && _ctx.existeDms && !_ctx.disabledButtonAtualizarEstoque]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.paginationConfig.data.length === 0 && !_ctx.animate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_el_empty, { description: "Nenhum serviço foi encontrado" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.animate)
        ? (_openBlock(), _createBlock(_component_ContentLoader, {
            key: 1,
            animate: true,
            viewBox: "0 0 900 488"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _hoisted_40,
              _hoisted_41,
              _hoisted_42,
              _hoisted_43
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.animate)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.paginationConfig.data, (produto, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "card shadow-sm mt-3 pt-2 position-relative d-flex"
            }, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    (produto?.servico?.length > 55)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "box-item",
                          effect: "dark",
                          placement: "top",
                          content: produto?.servico?.toUpperCase()
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.cortarString(produto?.servico?.toUpperCase())), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_48, _toDisplayString(_ctx.cortarString(produto?.servico?.toUpperCase())), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["px-2 maxwidth align-items-center text-nowrap", { 'text-muted': !_ctx.isEdit }])
                          }, _toDisplayString(produto?.codwynns ? produto?.codwynns : 'Não informado'), 3),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_55, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.servicoSelecionado(produto, index)),
                                  style: {"height":"100%","background":"var(--cor_btn_1_opct)","cursor":"pointer"},
                                  "data-toggle": "modal",
                                  "data-target": "#kt_modallog_1",
                                  class: "px-2 d-flex align-items-center"
                                }, _hoisted_58, 8, _hoisted_56)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["maxwidth px-2 align-items-center text-nowrap", { 'text-muted': !_ctx.isEdit }])
                          }, _toDisplayString(produto?.intServico ? produto?.intServico : 'Não informado'), 3),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_63, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.servicoSelecionado(produto, index)),
                                  style: {"height":"100%","background":"var(--cor_btn_1_opct)","cursor":"pointer"},
                                  class: "px-2 d-flex align-items-center"
                                }, _hoisted_66, 8, _hoisted_64)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["maxwidth px-2 align-items-center", { 'text-muted': !_ctx.isEdit }])
                          }, _toDisplayString(produto?.unidadesCaixa), 3),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_71, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.servicoSelecionado(produto, index)),
                                  style: {"height":"100%","background":"var(--cor_btn_1_opct)","cursor":"pointer"},
                                  class: "px-2 d-flex align-items-center"
                                }, _hoisted_74, 8, _hoisted_72)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, "R$ " + _toDisplayString(produto?.valorCompra.toLocaleString('pt-br',
                      {minimumFractionDigits: 2})), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("div", _hoisted_84, [
                        (produto.arrayMes.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produto.arrayMes, (venda, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (index < 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _createElementVNode("span", null, _toDisplayString(venda), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produto.arrayMes, (venda, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (index > 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                          _createElementVNode("span", null, _toDisplayString(venda), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_88, "Sem dados"))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("span", _hoisted_93, "Sem: " + _toDisplayString(produto.demandaSemanal ? produto.demandaSemanal
                      : 0), 1),
                        _createElementVNode("span", _hoisted_94, "Qui: " + _toDisplayString(produto.demandaQuinzenal ?
                      produto.demandaQuinzenal : 0), 1),
                        _createElementVNode("span", _hoisted_95, "Mês: " + _toDisplayString(produto.demandaMes ? produto.demandaMes : 0), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _hoisted_98,
                    _createTextVNode(),
                    _createElementVNode("span", _hoisted_99, _toDisplayString(produto?.estoque ? produto?.estoque : 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("span", _hoisted_102, _toDisplayString(produto?.ultNfDtFaturada ? produto?.ultNfDtFaturada : 'Não possui'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _hoisted_104,
                    _createElementVNode("span", _hoisted_105, _toDisplayString(produto?.ultNfFaturada ? 'NF' + produto?.ultNfFaturada : 'Não possui'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, [
                          (produto?.quantidadeSugeridaIconAlert)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_111, _hoisted_113))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("p", _hoisted_115, _toDisplayString(produto?.quantidadeSugerida), 1),
                            _hoisted_116
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            (produto?.unidadesCaixa > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                  _createElementVNode("i", {
                                    onClick: ($event: any) => (_ctx.simularCompra(produto, 'adicao')),
                                    style: {"background":"var(--cor_btn_1_opct)","border-radius":"0px 8px 0px 0px","cursor":"pointer","border":"none"},
                                    class: "p-2 fs-7 fas fa-plus cor_btn_1 d-flex align-items-start mb-2"
                                  }, null, 8, _hoisted_119)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                  _createVNode(_component_el_tooltip, {
                                    class: "box-item",
                                    effect: "dark",
                                    content: "Não possui unidade por caixa",
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("i", {
                                        onClick: ($event: any) => (_ctx.simularCompra(produto, 'adicao')),
                                        style: {"background":"var(--cor_btn_1_opct)","border-radius":"0px 8px 0px 0px","cursor":"not-allowed","opacity":"0.70"},
                                        class: "p-3 fas fa-plus cor_btn_1 d-flex align-items-start mb-3"
                                      }, null, 8, _hoisted_121)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])),
                            (produto?.unidadesCaixa > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                  _createElementVNode("i", {
                                    onClick: ($event: any) => (_ctx.simularCompra(produto, 'subtracao')),
                                    style: {"bottom":"0","background":"var(--cor_btn_1_opct)","border-radius":"0px 0px 8px 0px","cursor":"pointer"},
                                    class: "p-2 fs-7 fa fa-minus cor_btn_1 d-flex align-items-end"
                                  }, null, 8, _hoisted_123)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                  _createVNode(_component_el_tooltip, {
                                    class: "box-item",
                                    effect: "dark",
                                    content: "Não possui unidade por caixa",
                                    placement: "bottom"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("i", {
                                        onClick: ($event: any) => (_ctx.simularCompra(produto, 'subtracao')),
                                        style: {"bottom":"0","background":"var(--cor_btn_1_opct)","border-radius":"0px 0px 8px 0px","cursor":"not-allowed","opacity":"0.70"},
                                        class: "p-3 fa fa-minus cor_btn_1 d-flex align-items-end"
                                      }, null, 8, _hoisted_125)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _hoisted_129,
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_130, "R$ " + _toDisplayString(produto?.valoresSimulacao?.valorTotal ?
                              produto?.valoresSimulacao?.valorTotal.toLocaleString('pt-br',
                                { minimumFractionDigits: 2 }) : '0,00'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _hoisted_132,
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_133, _toDisplayString(produto?.valoresSimulacao?.novoEstoque ? produto?.valoresSimulacao.novoEstoque :
                          produto?.estoque), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (produto.isUpdated)
                ? (_openBlock(), _createElementBlock("p", _hoisted_134, "Esse produto não tem Atualização "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_135, [
        (!_ctx.animate && _ctx.paginationConfig.data.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
              _createElementVNode("button", {
                class: "btn btn-sm btn_background_salvar text-white",
                style: {"transition":"#606266"},
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.salvar())),
                disabled: _ctx.bloquearBotao
              }, _hoisted_139, 8, _hoisted_137)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.animate && _ctx.paginationConfig.data.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
              _createVNode(_component_spam, {
                class: "ms-2 me-2 total-product d-flex align-items-center justify-content-center",
                style: {"border-right":"solid 1px #B5B5C3"}
              }, {
                default: _withCtx(() => [
                  _hoisted_141,
                  _createElementVNode("span", null, " Total : R$ " + _toDisplayString(_ctx.valorTotalDosProdutos ?? _ctx.valorTotalDosProtutos), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.paginationConfig.data.length > 0 && !_ctx.animate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, "Exibindo " + _toDisplayString(_ctx.paginationConfig.to) + " de " + _toDisplayString(_ctx.paginationConfig.total) + " serviços", 1),
              (_ctx.paginationConfig.total > _ctx.paginationConfig.per_page)
                ? (_openBlock(), _createElementBlock("div", _hoisted_145, "Página " + _toDisplayString(_ctx.paginationConfig.current_page) + " de " + _toDisplayString(_ctx.paginationConfig.last_page), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_146, [
              (_ctx.paginationConfig.total > _ctx.paginationConfig.per_page)
                ? (_openBlock(), _createBlock(_component_el_pagination, {
                    key: 0,
                    id: "paginate",
                    background: "",
                    layout: "prev, pager, next",
                    "page-size": _ctx.paginationConfig.per_page,
                    onCurrentChange: _ctx.pagination,
                    total: _ctx.paginationConfig.total,
                    class: _normalizeClass({ current: _ctx.page === _ctx.current })
                  }, null, 8, ["page-size", "onCurrentChange", "total", "class"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.necessaryUpdateEstoque)
        ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
            _createElementVNode("div", {
              class: _normalizeClass({
          'position-absolute': true,
          'w-100': true,
          'ms-0': true,
          'ms-sm-4': true,
          'd-flex': true,
          'align-items-center': true,
          'toolTopAttentionOpen': _ctx.tooTipAttention,
          'toolTopAttentionClose': !_ctx.tooTipAttention,
          'width-tootip': true
        }),
              style: {"background":"#22B9FF","border-radius":"12px","z-index":"99","right":"15px","top":"150px"}
            }, [
              _hoisted_148,
              _createElementVNode("div", _hoisted_149, [
                _createElementVNode("span", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tooTipAttention = false, _ctx.necessaryUpdateEstoque = false)),
                  class: "position-absolute px-5 py-3",
                  style: {"right":"0px","top":"0px","cursor":"pointer"}
                }, "X"),
                _hoisted_150,
                _hoisted_151
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalUpdateCodFornecedor, {
      servico: _ctx.servicoSelecionadoModal,
      index: _ctx.indexServicoSelecionado,
      onCodFornecedor: _cache[6] || (_cache[6] = ($event: any) => (_ctx.novoCodFornecedor($event)))
    }, null, 8, ["servico", "index"]),
    _createVNode(_component_ModalUpdateCodPeca, {
      servico: _ctx.servicoSelecionadoModal,
      index: _ctx.indexServicoSelecionado,
      onCodPeca: _cache[7] || (_cache[7] = ($event: any) => (_ctx.novoCodPeca($event)))
    }, null, 8, ["servico", "index"]),
    _createVNode(_component_ModalUpdateUnidadeCaixa, {
      servico: _ctx.servicoSelecionadoModal,
      index: _ctx.indexServicoSelecionado,
      onUnidadePorCaixa: _cache[8] || (_cache[8] = ($event: any) => (_ctx.novoUnidadeCaixa($event)))
    }, null, 8, ["servico", "index"])
  ]))
}